<template>
    <div class="container py-5">
      <h3>Sessão expirada</h3>
      <p>Sua sessão expirou por segurança. Você será redirecionado para o login.</p>
  
      <div class="mt-3">
        <button class="btn btn-primary" @click="irAgora">Ir para o login agora</button>
      </div>
  
      <small class="text-muted d-block mt-3">
        Redirecionando em {{ segundos }}s...
      </small>
    </div>
  </template>
  
  <script>
    import router from "@/router";

  export default {
    name: "SessaoExpirada",
    data() {
      return { segundos: 3, timer: null };
    },
    mounted() {
      var self = this;
      this.timer = setInterval(function () {
        self.segundos--;
        if (self.segundos <= 0) self.irAgora();
      }, 1000);
    },
    beforeDestroy() {
      if (this.timer) clearInterval(this.timer);
    },
    methods: {
      irAgora() {
        if (this.timer) clearInterval(this.timer);
        router.replace({ name: "Login", query: { reason: "expired" } });
      }
    }
  };
  </script>
  